import { Grid } from "@mui/material";
import { Fragment, useState, useEffect } from "react";

import { useAxios } from "../../hooks";
import { PageHeader, Pagination } from "../../components";
import BrandList from "./onboarding list components/BrandList";
import { PrimaryButton } from "../css components/Button";
import { useNavigate } from "react-router-dom";
import pages from "../../constants/pages";

export default function OnBoardedConnectionList() {
  const axios = useAxios();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [dpList, setDpList] = useState([]);

  const [page, setPage] = useState({
    page: 1,
  });
  const [sortBy, setSortBy] = useState("NODE");
  const [platformTenants, setPlatformTenantList] = useState([]);

  const [searchKey, setSearchKey] = useState("");
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  useEffect(() => {
    setLoading(true);
    axios({
      url: "/list/dynamicDashboard",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setPlatformTenantList(response.data);
      }
    });
    axios({
      url:
        "/user/getAllDataPartner" +
        `?page=${page.page}&limit=10` +
        (searchKey ? `&search=${searchKey}` : "") +
        (sortBy ? `&type_method=${sortBy}` : ""),
    }).then((response) => {
      if (response.status) {
        if (response.data.data.length > 0) {
          setDpList(response.data.data);

          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: response.data.data.length < 10,
          });
        } else {
          setDpList(response.data);

          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: true,
          });
        }

        setLoading(false);
      }
    });
  }, [axios, searchKey, page, sortBy]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"Onboarded Brands"}
            pageHeader={"List of onboarded brands"}
            buttons={[
              <PrimaryButton
                variant="contained"
                onClick={() => navigate(pages.dpOnBoarding.route)}
              >
                New Onboarding
              </PrimaryButton>,
            ]}
          />
        </Grid>
      </Grid>

      <BrandList
        platformTenants={platformTenants}
        loading={loading}
        dpList={dpList}
        setPage={setPage}
        sortBy={sortBy}
        setSortBy={setSortBy}
        setSearchKey={setSearchKey}
      />

      {!!lastPage.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
